import React, { useContext, useState } from 'react';
import TeacketContext from 'src/context/TeacketContext';
import { useNavigate } from 'react-router-dom';
import { Space, Input, Button, Form, notification } from 'antd';
import useAsyncProcesses from 'src/hooks/useAsyncProcesses';
import { postTicket } from 'src/api/teacket';
import useUserInfo from 'src/hooks/useUserInfo';
import { Select } from 'antd';
import { notEmptyArray } from 'src/misc/Misc';
//import PropTypes from 'prop-types';

const TicketCreateControl = () => {
  const userInfo = useUserInfo();
  const navigate = useNavigate();
  const { executeAsyncProcess } = useAsyncProcesses();
  const [createTicketForm] = Form.useForm();
  const { servicesForTenant } = useContext(TeacketContext);

  //#region "FORM HANDLERS"

  const handleFormOnFinish = async (values) => {
    console.log('Success:', values);
    const body = { ...values, content: values?.content?.replace(/\n/g, '<br />'), owner_id: userInfo.id, status: createTicketForm.getFieldValue('status') };

    await executeAsyncProcess(async () => {
      try {
        console.log('userInfo', userInfo);
        const ticket = await postTicket(body);
        notification.success({ message: 'Ticket submitted successfully' });
        if (ticket) {
          navigate(`/teacket/tickets/${ticket.id}`);
        }
      } catch (error) {
        console.error(error);
      }
    });
  };

  const handleFormOnFailure = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const handleFormReset = () => {
    setSubCategoryList([]);
    setCategoryList([]);
    setPriorityList([]);
  };

  const handleOnServiceChange = (value) => {
    console.log('Selected service:', value);
    setDefaultStatus(value);
    setPriorityOptions(value);
    setCategoryOptions(value);
  };

  const handleOnCategoryChange = (value) => {
    console.log('Selected category:', value);
    setSubCategoryOptions(value);
  };

  //#endregion

  //#region "VALUES MANIPULATION"

  const [priorityList, setPriorityList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);

  const setPriorityOptions = (service_id) => {
    console.log('setPriorityOptions', service_id);
    try {
      const service = servicesForTenant?.find((service) => service.id === service_id);
      setPriorityList(true === notEmptyArray(service?.props?.priorityList) ? service?.props?.priorityList : []);
      const defaultPriority = service?.props?.priorityList?.find((status) => true === status.default);
      if (!defaultPriority) return;
      createTicketForm.setFieldValue('priority', defaultPriority.priority);
    } catch (error) {
      console.error(error);
      notification.error({ message: 'Failed to load priority options' });
    }
  };

  const setDefaultStatus = (service_id) => {
    console.log('setDefaultStatus', service_id);
    try {
      const service = servicesForTenant?.find((service) => service.id === service_id);
      const defaultStatus = service?.props?.statusList?.find((status) => true === status.default);
      if (!defaultStatus) throw new Error('Default status not found');
      createTicketForm.setFieldValue('status', defaultStatus.status);
    } catch (error) {
      console.error(error);
      notification.error({ message: 'Failed to load status' });
    }
  };

  const setCategoryOptions = (service_id) => {
    console.log('setCategoryOptions', service_id);
    try {
      const service = servicesForTenant?.find((service) => service.id === service_id);
      setCategoryList(true === notEmptyArray(service?.props?.categoryList) ? service.props?.categoryList : []);
    } catch (error) {
      console.error(error);
      notification.error({ message: 'Failed to load category options' });
    }
  };

  const setSubCategoryOptions = (category) => {
    console.log('setSubCategoryOptions', category);
    try {
      const service = servicesForTenant?.find((service) => service.id === createTicketForm.getFieldValue('service_id'));
      const categoryItem = service?.props?.categoryList?.find((item) => item.category === category);
      setSubCategoryList(true === notEmptyArray(categoryItem?.items) ? categoryItem.items : []);
    } catch (error) {
      console.error(error);
      notification.error({ message: 'Failed to load sub category options' });
    }
  };
  //#endregion

  return (
    <div>
      <Form form={createTicketForm} name='ticket-create-form' initialValues={{ remember: true }} onFinish={handleFormOnFinish} onFinishFailed={handleFormOnFailure} onReset={handleFormReset} autoComplete='off' layout='vertical'>
        <div>
          <div>
            <Form.Item label='Service' name='service_id' rules={[{ required: true, message: 'This field is required' }]}>
              <Select placeholder='Select a service...' onChange={handleOnServiceChange}>
                {servicesForTenant?.map((service) => (
                  <Select.Option key={service.id} value={service.id}>
                    {service.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item label='Category' name='category' rules={[{ required: true, message: 'This field is required' }]}>
              <Select placeholder='Select a category...' onChange={handleOnCategoryChange} disabled={!createTicketForm.getFieldValue('service_id')}>
                {categoryList?.map((item) => (
                  <Select.Option key={item.category} value={item.category}>
                    {item.category}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item label='Sub Category' name='sub_category' rules={[{ required: true, message: 'This field is required' }]}>
              <Select placeholder='Select a sub category...' disabled={!createTicketForm.getFieldValue('category')}>
                {subCategoryList?.map((item) => (
                  <Select.Option key={item.subCategory} value={item.subCategory}>
                    {item.subCategory}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item label='Priority' name='priority' rules={[{ required: true, message: 'This field is required' }]}>
              <Select placeholder='Select a priority...' disabled={!createTicketForm.getFieldValue('service_id')}>
                {priorityList?.map((item) => (
                  <Select.Option key={item.priority} value={item.priority}>
                    {item.priority}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item label='Title' name='title' rules={[{ required: true, message: 'This field is required' }]}>
              <Input placeholder='Enter a short description...' autoSize={{ minRows: 2, maxRows: 6 }} maxLength={150} showCount disabled={!createTicketForm.getFieldValue('service_id')} />
            </Form.Item>

            <Form.Item label='Content' name='content' rules={[{ required: true, message: 'This field is required' }]}>
              <Input.TextArea placeholder='Enter a problem description...' autoSize={{ minRows: 4, maxRows: 8 }} maxLength={500} showCount disabled={!createTicketForm.getFieldValue('service_id')} />
            </Form.Item>
          </div>
        </div>
        <div className='mt-4'>
          <Form.Item>
            <Space>
              <Button htmlType='reset'>Reset</Button>
              <Button type='primary' htmlType='submit'>
                Submit
              </Button>
            </Space>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

TicketCreateControl.propTypes = {};

export default TicketCreateControl;
